/**
 * Products sold by the unit (Jaron, Oct 15 2026, 13312379361: "Need to have +
 * on all home service products"). The price calculator gives the price of
 * one unit; the Qty field multiplies it. Before this a second AC had to be
 * entered as a Custom row, which lost the AC calculator and showed up as two
 * unrelated lines.
 *
 * Products that already ask for their own count (attic fans, thermostats,
 * ducts, panels…) price it in their calculator and are not listed here.
 */
export const efficiencyToQtyField: Readonly<Record<string, string>> = {
  air_conditioner: 'air_conditioner_qty',
}

/** How many units of a product the customer is buying; 1 when not counted. */
export const efficiencyUnits = (
  efficiency: string,
  customer: Readonly<Record<string, unknown>>,
): number => {
  const field = efficiencyToQtyField[efficiency]
  if (!field) return 1
  const n = Number(customer[field])
  return Number.isFinite(n) && n >= 1 ? Math.floor(n) : 1
}

/** "2 x HVAC Replacement…" so the notes say how many the price covers. */
export const notesWithUnits = (notes: string, units: number): string =>
  units > 1 && notes ? `${units} x ${notes}` : notes
